import React from "react";
import styled from 'styled-components'
import { motion } from 'framer-motion'

const FadeIn = styled<any>(motion.div).attrs(props => ({
    className: props.className ? props.className : '',
    initial: { opacity: 0 },
    animate: { opacity: 1 }
}))``

export default FadeIn;